import get from 'lodash/get';

export const includeKeys = [
  'action',
  'section',
  'error',
  'validationErrors',

  'activeEvent.event_time_start',
  'activeEvent.event_time_end',
  'activeEvent.event_type',
  'activeEvent.event_agent.name',

  'openHome.listing_sale_or_rental',
  'openHome.price_match',
  'openHome.price_rent',
  'openHome.property_category',

  'openHome.account.name',

  'openHome.address.latitude',
  'openHome.address.longitude',
  'openHome.address.postcode ',
  'openHome.address.state_or_region',
  'openHome.address.street_name',
  'openHome.address.street_number',
  'openHome.address.suburb_or_town',
  'openHome.address.unit_number',

  'openHome.attributes.bathrooms',
  'openHome.attributes.bedrooms',
  'openHome.attributes.total_car_accom',
  'openHome.attributes.landarea',
  'openHome.attributes.landarea_unit',
  'openHome.attributes.landarea_m2',

  'user.email',
  'user.first_name',
  'user.last_name',
  'user.phone',
  'user.postcode'
];

export function transformData(data, includeKeys) {
  return includeKeys.reduce((acc, key) => {
    const formattedKey = key.replace(/(\.|_)\w/g, (matchedChars) =>
      matchedChars[1].toUpperCase()
    );
    const value = get(data, key);

    if (value) acc[formattedKey] = value;

    return acc;
  }, {});
}
